import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import ArticlePage from "@/pages/article/page";
import PillarArticlePage from "@/pages/pillar/page";
import ProductsPage from "@/pages/products/page";
import AboutPage from "@/pages/about/page";
import ContactPage from "@/pages/contact/page";
import DisclaimerPage from "@/pages/disclaimer/page";
import PrivacyPage from "@/pages/privacy/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/pt",
    element: <Home />,
  },
  {
    path: "/pt/",
    element: <Home />,
  },
  {
    path: "/de",
    element: <Home />,
  },
  {
    path: "/de/",
    element: <Home />,
  },
  {
    path: "/en",
    element: <Home />,
  },
  {
    path: "/en/",
    element: <Home />,
  },
  // Spreadsheet hub
  {
    path: "/cssbuy-spreadsheet/",
    element: <Home />,
  },
  {
    path: "/pt/cssbuy-spreadsheet/",
    element: <Home />,
  },
  {
    path: "/de/cssbuy-spreadsheet/",
    element: <Home />,
  },
  {
    path: "/en/cssbuy-spreadsheet/",
    element: <Home />,
  },
  // Products catalog
  {
    path: "/products/",
    element: <ProductsPage />,
  },
  {
    path: "/produtos/",
    element: <ProductsPage />,
  },
  {
    path: "/produkte/",
    element: <ProductsPage />,
  },
  {
    path: "/pt/produtos/",
    element: <ProductsPage />,
  },
  {
    path: "/de/produkte/",
    element: <ProductsPage />,
  },
  {
    path: "/en/products/",
    element: <ProductsPage />,
  },
  // Article pages
  {
    path: "/cssbuy-spreadsheet-guia/",
    element: <ArticlePage />,
  },
  {
    path: "/pt/cssbuy-spreadsheet-guia/",
    element: <ArticlePage />,
  },
  {
    path: "/cssbuy-spreadsheet-anleitung/",
    element: <ArticlePage />,
  },
  {
    path: "/de/cssbuy-spreadsheet-anleitung/",
    element: <ArticlePage />,
  },
  {
    path: "/cssbuy-spreadsheet-guide/",
    element: <ArticlePage />,
  },
  {
    path: "/en/cssbuy-spreadsheet-guide/",
    element: <ArticlePage />,
  },
  // Pillar articles (dynamic)
  {
    path: "/guides/:slug",
    element: <PillarArticlePage />,
  },
  {
    path: "/guides/:slug/",
    element: <PillarArticlePage />,
  },
  // About
  {
    path: "/about/",
    element: <AboutPage />,
  },
  {
    path: "/pt/sobre/",
    element: <AboutPage />,
  },
  {
    path: "/de/ueber-uns/",
    element: <AboutPage />,
  },
  {
    path: "/en/about/",
    element: <AboutPage />,
  },
  // Contact
  {
    path: "/contact/",
    element: <ContactPage />,
  },
  {
    path: "/pt/contato/",
    element: <ContactPage />,
  },
  {
    path: "/de/kontakt/",
    element: <ContactPage />,
  },
  {
    path: "/en/contact/",
    element: <ContactPage />,
  },
  // Disclaimer
  {
    path: "/disclaimer/",
    element: <DisclaimerPage />,
  },
  {
    path: "/pt/aviso-legal/",
    element: <DisclaimerPage />,
  },
  {
    path: "/de/haftungsausschluss/",
    element: <DisclaimerPage />,
  },
  {
    path: "/en/disclaimer/",
    element: <DisclaimerPage />,
  },
  // Privacy
  {
    path: "/privacy/",
    element: <PrivacyPage />,
  },
  {
    path: "/pt/privacidade/",
    element: <PrivacyPage />,
  },
  {
    path: "/de/datenschutz/",
    element: <PrivacyPage />,
  },
  {
    path: "/en/privacy/",
    element: <PrivacyPage />,
  },
  // Not found
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;